module.exports = __webpack_public_path__ + "static/media/staffpad-small.9e59fd6e.png";